/**
 * Application constants
 */

export const APP_NAME = 'Signal Bridge';

// Routes
export const ROUTES = {
  LOGIN: '/login',
  ONBOARD: '/onboard',
  DASHBOARD: '/dashboard',
  DEMO: '/demo',
  ADMIN: '/admin',
  ROLE_EDITOR: '/admin/role-editor',
  TEST_TOOLS: '/admin/test-tools',
  REST_TEST_TOOLS: '/admin/tools/rest',
  AGENT_DASHBOARD: '/admin/agent-dashboard',
  API_TEST_TOOLS: '/admin/api-test',
  SETTINGS: '/settings',
  HOME: '/',
  HOME_LAUNCHER: '/home',
  LAUNCHER_SETTINGS: '/home/settings',
  AMBIENT: '/ambient',
  USER_MANAGEMENT: '/admin/user-management',
  ADMIN_AGREEMENTS: '/admin/agreements',
  SUPPORT_REPORTS: '/support/reports',
  SUPPORTED_TENANTS: '/support/tenants',
  SUPPORTED_TENANT: '/support/tenants/:tenantId',
  SUPPORT_REPORT_DETAIL: '/support/detail',
  MY_REPORTS: '/my-reports',
  MY_REPORT_DETAIL: '/my-reports/detail',
  SUBSCRIPTION: '/subscription',
  RELEASE_NOTES: '/release-notes',
  // New backend auth routes
  BACKEND_LOGIN: '/backend-login',
  BACKEND_DASHBOARD: '/backend-dashboard',
  // Admin API test tool
  API_TEST_PAGE: '/admin/api-test',
  // Agent Dashboard
  AGENT_DASHBOARD: '/admin/agent-dashboard',
  AGENT_MANAGEMENT: '/admin/agent-management',
  TOUCH_PANEL_DESIGNER: '/admin/touch-panels',
  TOUCH_PANEL_EDITOR: '/admin/touch-panels/:panelId',
  // Algo Devices Admin Page
  ADMIN_ALGO_DEVICES: '/admin/algo-devices',
  // Admin Event System Pages
  ADMIN_TEMPLATES: '/admin/event-system/templates',
  ADMIN_FLOWS: '/admin/event-system/flows',
  ADMIN_ACTIONS: '/admin/event-system/actions',
  ADMIN_DEVICES: '/admin/event-system/devices',
  ADMIN_LOGS: '/admin/event-system/logs',
  ADMIN_INCOMING_EVENTS: '/admin/event-system/incoming-events',
  ADMIN_TENANTS: '/admin/tenants',
  ADMIN_TENANT_DETAIL: '/admin/tenants/:tenantId',
  ADMIN_SUPPORT: '/admin/support',
  ADMIN_BILLING: '/admin/billing',
  ADMIN_PRICING: '/admin/pricing',
  ADMIN_DEALERS: '/admin/dealers',
  ADMIN_DEALER_DETAIL: '/admin/dealers/:dealerId',
  ADMIN_ALL_USERS: '/admin/all-users',
  ADMIN_BACKUP_RECOVERY: '/admin/backup-recovery',
  DEALER_WORKSPACE: '/dealer',
  DEALER_WORKSPACE_DEALER: '/dealer/:dealerId',
  DEALER_WORKSPACE_TENANT: '/dealer/:dealerId/tenants/:tenantId',
  DEALER_MANAGE_TENANT: '/dealer/:dealerId/tenants/:tenantId/manage',
  VOICE_SETTINGS: '/admin/voice-settings',
  VOICE_DASHBOARD: '/admin/voice-dashboard',
  INBOUND_RULES: '/admin/event-system/inbound-rules',
  SCHEDULED_TRIGGERS: '/admin/event-system/scheduled',
  SIMPLE_ACTIONS: '/admin/event-system/simple-actions',
  SIP_INTERWORKING: '/admin/event-system/sip-interworking',
  CALL_ROUTING: '/admin/event-system/call-routing',
  CONFIG_EDITOR: '/admin/config-editor/:deviceId',
  CONFIG_WORKSPACE: '/admin/config-workspace',
  CONFIG_SNAPSHOTS: '/admin/config-snapshots',
  CONFIG_PARSED: '/admin/configs/:deviceId/parsed',
  SEGMENT_HEALTH: '/admin/segment-health',
  ACTIVITY_FEED: '/activity-feed',
  ADMIN_WORKSPACES: '/admin/workspaces',
  ADMIN_SHORTCUTS: '/admin/shortcuts',
  ADMIN_ASK_SB: '/admin/integrations',
  ADMIN_WORKSPACE_DETAIL: '/admin/workspaces/:id',
  STUDIO: '/studio',
  STUDIO_WORKSPACE: '/studio/:workspaceId',
  ADMIN_CONTACT_LISTS: '/admin/contact-lists',
  TRAINING: '/training',
};

// Roles
export const ROLES = {
  SUPERADMIN: 'superadmin',
  ADMIN: 'admin',
  TENANT_ADMIN: 'tenant_admin',
  RESPONDER: 'responder',
  DEMO_USER: 'demo_user',
  SUPPORT_USER: 'support_user',
  OVERSEER: 'overseer',
  OPERATOR: 'operator',
  VIEWER: 'viewer',
  SITE_ADMIN: 'site_admin',
  USER: 'user',
};

// Firebase collections
export const COLLECTIONS = {
  USERS: 'users',
};

// Local storage keys
export const STORAGE_KEYS = {
  AUTH_USER: 'canalerts_auth_user',
};
